import styles from "./styles.module.scss";
import creditCard from "../../assets/creditCard.svg";
import tabby from "../../assets/tabby.png";
import tamara from "../../assets/tamara.png";
import masterCard from "../../assets/masterCard.svg";
import vissaCard from "../../assets/vissaCard.svg";
import General from "../../stores/GeneralStore";
import React, { useEffect, useState } from "react";
import CloseIcon from "../../assets/CloseIcon.svg";
import Close from "../../assets/close.png";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import CardsStore from "../../stores/CardsStore";
import { merge } from "antd/es/theme/util/statistic";
import {PAYMENT_METHODS_CONFIG} from "../../utils/constants";
import { filsToAmountString, formatAmount, toFils } from "../../utils/money";

declare global {
  interface Window {
    TabbyPromo?: any;
  }
}

declare global {
  interface Window {
    TamaraPromo?: any;
  }
}

declare global {
  interface Window {
    tamaraWidgetConfig?: {
      lang: string;
      country: string;
      publicKey: string;
    };
  }
}

interface AppConfig {
  "IsNI" : boolean,
  "IsTabby" : boolean,
  "IsTamara" : boolean,
  "TabbyPublicKey": string,
  "TabbyPromoUrl" : string,
  "TamaraPromoUrl" : string,
  "TamaraPublicKey": string,
  "merchantCode": string
}


export interface GatewaySelectionProps {
  paymentData: Record<string, any>;
  handlePayment: (data: any, gatewayType: string) => Promise<{ result: any }>;
  onClose: () => void;
  emailForm?: boolean;
  amount?: any;
  rentalDues?: boolean;
  user?: any;
  checkTabbyEligibility?: any;
  checkTamaraEligibility?: any;
}

export const GatewaySelection: React.FC<GatewaySelectionProps> = ({
  paymentData,
  handlePayment,
  onClose,
  emailForm,
  amount,
  rentalDues,
  user,
  checkTabbyEligibility,
  checkTamaraEligibility,
}) => {
  const [selected, setSelected] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [email, setEmail] = useState("");
  const emailRef = React.useRef("");
  const [mobile, setMobile] = useState("");
  const mobileRef = React.useRef("");
  const [tabbyErrorMessage, setTabbyErrorMessage] = useState("");

  const [isTabbyVisible, setIsTabbyVisible] = useState(false);
  const [isTabbyEligible, setIsTabbyEligible] = useState(false);
  const [isAmountligible, setIsAmountEligible] = useState(false);
  const [isTamaraAmountEligible, setIsTamaraAmountEligible] = useState(false);
  const [tamaraMessage, setTamaraMessage] = useState("");
  const [config, setConfig] = useState<AppConfig | null>(null);

  const isEmailValid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
  const isMobileValid = /^5\d{8}$/.test(mobile);
  const shouldEnable = isEmailValid && isMobileValid;

  const rawAmount = amount ?? paymentData?.amount;
  const parsedFils = toFils(rawAmount);
  const amountFils = parsedFils ?? 0;
  /** False when the amount could not be read at all - blocks submission below. */
  const isAmountUsable = parsedFils !== null && parsedFils > 0;

  /** Grouped form for display only ("1,234.56"). */
  const amounts = formatAmount(rawAmount);
  /**
   * Plain 2-decimal form for anything that consumes the value rather than
   * showing it. The grouped display string must never be sent: parseFloat and
   * most parsers stop at the comma, so "1,234.56" is read as 1.
   */
  const amountValue = filsToAmountString(amountFils);

  const Promoamount = amountValue;
  const handleGetCardsList = async () => {
    await CardsStore.getCardsList({ errorId: "getCardsListError" });
  };
  const getCurrentLAn = () => {
    if (General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "ARA")
      return "ar";
    if (General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "HIN")
      return "hi";
    return "en";
  };
  const currentLAn = getCurrentLAn();

  useEffect(() => {
  async function loadConfig() {
    try {
      const response = await fetch('/config/config.json'); 
      const json = await response.json();
      setConfig(json);
    } catch (err) {
      console.error("Error loading config:", err);
    }
  }
  loadConfig();
}, []);


  //logged-in users eligibility check - Tabby
  useEffect(() => {
    handleGetCardsList();
     if (!config?.IsTabby) return;

    if (!emailForm && user?.profile?.personId && checkTabbyEligibility) {
      const checkEligibility = async () => {
        try {
          const { isEligible, message, isAmountEligible } =
            await checkTabbyEligibility({
              amount: amountValue,
              email: user?.profile?.email,
              mobile: user?.profile?.mobileNumber,
            });
          setIsTabbyVisible(!!isEligible);
          setIsTabbyEligible(!!isEligible);
          setIsAmountEligible(!!isAmountEligible);
          if (isAmountEligible == false && message) {
            setTabbyErrorMessage(General?.codeLabels[message.toLowerCase()]?.label?General?.codeLabels[message.toLowerCase()]?.label:message);
          }
        } catch (err) {
          console.error("Tabby eligibility check failed:", err);
          setIsTabbyVisible(false);
          setIsTabbyEligible(false);
        }
      };
      checkEligibility();
    }
  }, [user?.profile?.personId, paymentData?.amount, config]);

  //non-logged (emailForm) users dynamic eligibility check -Tabby
  useEffect(() => {
    if (!emailForm || !checkTabbyEligibility) return;

    const validateAndCheck = async () => {
      if (isEmailValid && isMobileValid) {
        try {
           if (config?.IsTamara){
             runTamaraEligibility({
            amount: amountValue,
            email: emailRef.current,
            mobile: `+971${mobileRef.current}`,
          });
           }
         if(config?.IsTabby){
            const { isEligible, message, isAmountEligible } =
            await checkTabbyEligibility({
              amount: amountValue,
              email: emailRef.current,
              mobile: `+971${mobileRef.current}`,
            });

          setIsTabbyVisible(true);
          setIsTabbyEligible(!!isEligible);
          setIsAmountEligible(!!isAmountEligible);

          if (message) {
            setTabbyErrorMessage(General?.codeLabels[message.toLowerCase()]?.label?General?.codeLabels[message.toLowerCase()]?.label:message);
          } else {
            setTabbyErrorMessage("");
          }
         }

         
        } catch (err) {
          console.error("Eligibility check failed:", err);
          setIsTabbyVisible(true);
          setIsTabbyEligible(false);
        }
      } else {
        setIsTabbyVisible(true);
        setIsTabbyEligible(false);
      }
    };

    validateAndCheck();
  }, [email, mobile, isEmailValid, isMobileValid, config]);

  //eligibility check - Tamara
  useEffect(() => {
    handleGetCardsList();
    if (!config?.IsTamara) return;
    runTamaraEligibility({
      amount: amountValue,
      email: user?.profile?.email,
      mobile: user?.profile?.mobileNumber,
    });
  }, [user?.profile?.personId, paymentData?.amount, config]);

  const runTamaraEligibility = async ({ amount, email, mobile }: any) => {
    try {
      const { message, isAmountEligible } = await checkTamaraEligibility({
        amount,
        email,
        mobile,
      });

      setIsTamaraAmountEligible(!!isAmountEligible);

      if (!isAmountEligible && message) {
        setTamaraMessage(General?.codeLabels[message.toLowerCase()]?.label?General?.codeLabels[message.toLowerCase()]?.label:message);
      } else {
        setTamaraMessage("");
      }
    } catch (err) {
      console.error("Tamara eligibility check failed:", err);
      setIsTamaraAmountEligible(false);
    }
  };

  const language = currentLAn === "ar" ? "ar" : "en";
  //tabby promo
  useEffect(() => {
     if (!config || !config?.IsTabby) return;
    const scriptId = "tabby-promo-script";

    const initTabbyPromo = () => {
      if (!window.TabbyPromo) return;

      try {
        const promoContainer = document.querySelector("#TabbyPromo");
        if (promoContainer) promoContainer.innerHTML = "";

        new window.TabbyPromo({
          selector: "#TabbyPromo",
          currency: "AED",
          price: Promoamount,
          lang: language,
          source: "cart",
          publicKey: config?.TabbyPublicKey,
          merchantCode: config?.merchantCode,
          styleConfig: { hasBorder: false },
        });
      } catch (err) {
        console.error("Error initializing TabbyPromo:", err);
      }
    };

    const loadScript = () => {
      if (!document.getElementById(scriptId)) {
        const script = document.createElement("script");
        script.id = scriptId;
        script.src = config?.TabbyPromoUrl;
        script.async = true;
        script.onload = () => setTimeout(initTabbyPromo, 300);
        document.body.appendChild(script);
      } else {
        setTimeout(initTabbyPromo, 300);
      }
    };

    if (isTabbyVisible) loadScript();

    return () => {
      const promoContainer = document.querySelector("#TabbyPromo");
      if (promoContainer) promoContainer.innerHTML = "";
    };
  }, [Promoamount, isTabbyVisible, config]);

  //tamara promo

  useEffect(() => {
     if (!config || !config?.IsTamara) return;
    const badgePos = language === "ar" ? "left" : "right";
    const renderTamaraWidget = () => {
      const container = document.getElementById("TamaraPromo");
      if (container) {
        container.innerHTML = `
          <tamara-widget
            type="tamara-summary"
            amount="${Promoamount}"
            inline-type="2"
            inline-variant="text"
            config='{"badgePosition":"${badgePos}","showExtraContent":true,"hidePayInX":false}'
          ></tamara-widget>
        `;
      }
    };

    window.tamaraWidgetConfig = {
      lang: language === "ar" ? "ar" : "en",
      country: "AE",
      publicKey: config?.TamaraPublicKey,
    };

    const scriptId = "tamara-widget-script";
    const existing = document.getElementById(scriptId);

    if (!existing) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = config?.TamaraPromoUrl;
      script.defer = true;

      script.onload = () => {
        renderTamaraWidget();
      };

      document.body.appendChild(script);
    } else {
      renderTamaraWidget();
    }
  }, [Promoamount, language, config]);

  //disable back button
  useEffect(() => {
    const handleBackPress = () => {
      onClose();
    };

    window.history.pushState({ modalOpen: true }, "");
    window.addEventListener("popstate", handleBackPress);

    return () => {
      window.removeEventListener("popstate", handleBackPress);
    };
  }, []);

  const handleContinue = async (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!selected) {
      alert("Please select a payment method.");
      return;
    }

    // An amount we could not parse must not be submitted: toFils returned null
    // and amountFils fell back to 0, so continuing here would send a plausible
    // AED 0.00 payment for a real balance. money.ts is explicit that null is an
    // error on the payment path, not a zero.
    if (!isAmountUsable) {
      alert(
        General?.codeLabels["cm_invalid_amount"]?.label
          ? General?.codeLabels["cm_invalid_amount"]?.label
          : "This payment amount could not be read. Please reload and try again."
      );
      return;
    }

    try {
      if (selected === "ni" || selected.startsWith("saved_")) {
        setIsLoading(true);

        if (emailForm) {
          if (rentalDues) {
            paymentData = {
              ...paymentData,
              emailAddress: emailRef.current,
              mobile: isMobileValid ? `+971${mobileRef.current}` : "",
            };
          }
          paymentData = {
            ...paymentData,
            email: emailRef.current,
            mobile: isMobileValid ? `+971${mobileRef.current}` : "",
          };
        }

        if (selected.startsWith("saved_")) {
          const cardIndex = parseInt(selected.replace("saved_", ""));
          const chosenCard = CardsStore?.list?.cards?.[cardIndex];

          if (chosenCard) {
            paymentData = {
              ...paymentData,
              card: chosenCard,
            };
          }
        }
        const { result } = await handlePayment(paymentData, "ni");
        setIsLoading(false);
        // onClose();
        window.location.href = result;
      } else if (selected === "tabby") {
        setIsLoading(true);

        if (emailForm) {
          paymentData = {
            ...paymentData,
            email: emailRef.current,
            mobile: isMobileValid ? `+971${mobileRef.current}` : "",
          };
        }
        const { result } = await handlePayment(paymentData, "tabby");
        setIsLoading(false);
        window.location.href = result;
      } else if (selected === "tamara") {
        setIsLoading(true);

        if (emailForm) {
          paymentData = {
            ...paymentData,
            email: emailRef.current,
            mobile: isMobileValid ? `+971${mobileRef.current}` : "",
          };
        }

        const { result } = await handlePayment(paymentData, "tamara");
        setIsLoading(false);
        // onClose();
        window.location.href = result;
      }
    } catch (err: any) {
      console.error("Payment init failed", err.message);
      setIsLoading(false);
    }
  };

  return (
    <div className={`${styles.paymentPage}`}>
      {CardsStore?.list?.cards?.length > 0 ? (
        <div className={`${styles.paymentbase}`}>
          <div className={styles.paymentWrap}>
            <div className={styles.paymentSection}>
              {emailForm && (
                <div className={styles.paymentHead}>
                  <div className={styles.modalHeader}>
                    <h3 className={`${styles.headingH3} mb-4`}>
                      {General?.codeLabels["cm_payment_enter_details"]
                        ?.label !== undefined
                        ? General?.codeLabels["cm_payment_enter_details"]?.label
                        : "Enter Your Details to Proceed with Payment"}
                    </h3>
                    {emailForm ? (
                      <button
                        className={`${styles.btnClose}`}
                        onClick={onClose}
                      >
                        <img src={Close} alt="close" />
                      </button>
                    ) : null}
                  </div>
                  <div className="form-group mb-0">
                    <label
                      className={` ${styles.formLabel} ${styles.required}`}
                    >
                      {General?.codeLabels["cm_payment_email"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_payment_email"]?.label
                        : "Email"}
                    </label>
                    <input
                      type="text"
                      className={styles.formControl}
                      placeholder={
                        General?.codeLabels["cm_payment_enter_email"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_payment_enter_email"]?.label
                          : "Enter your email"
                      }
                      value={email}
                      maxLength={254}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        emailRef.current = e.target.value;
                      }}
                    />
                    {email.length > 0 && !isEmailValid && (
                      <span style={{ color: "red", fontSize: "13px" }}>
                        {General?.codeLabels["cm_payment_email_msg"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_payment_email_msg"]?.label
                          : "Please enter a valid email address"}
                      </span>
                    )}
                  </div>
                  <div className={`form-group mb-0 ${styles["mt-3"]}`}>
                    <label
                      className={` ${styles.formLabel} ${styles.required}`}
                    >
                      {General?.codeLabels["cm_payment_mobile_number"]
                        ?.label !== undefined
                        ? General?.codeLabels["cm_payment_mobile_number"]?.label
                        : "Mobile Number"}
                    </label>
                    <div className={styles.phoneInput}>
                      <input
                        type="text"
                        value="+971"
                        disabled
                        className={`${styles.formControl} ${styles.prefixInput}`}
                      />
                      <input
                        type="text"
                        className={styles.formControl}
                        placeholder={
                          General?.codeLabels["cm_payment_enter_number"]
                            ?.label !== undefined
                            ? General?.codeLabels["cm_payment_enter_number"]
                                ?.label
                            : "Enter your number"
                        }
                        value={mobile}
                        onChange={(e) => {
                          setMobile(e.target.value);
                          mobileRef.current = e.target.value;
                        }}
                      />
                    </div>
                    {mobile.length > 0 && !isMobileValid && (
                      <span style={{ color: "red", fontSize: "13px" }}>
                        {General?.codeLabels["cm_payment_mobile_msg"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_payment_mobile_msg"]?.label
                          : "Please enter a valid mobile number (5X-XXX-XXXX)"}
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div className={styles.PaymentMethod}>
                <div className={styles.modalHeader}>
                  <h3 className={`${styles.headingH3} mb-3`}>
                    {General?.codeLabels["cm_payment_select_method"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_payment_select_method"]?.label
                      : "Select a Payment Method"}
                  </h3>
                  {!emailForm ? (
                    <button className={`${styles.btnClose}`} onClick={onClose}>
                      <img src={Close} alt="close" />
                    </button>
                  ) : null}
                </div>
                <div className={styles.cardPayment}>
                 {config?.IsNI && (
                  <div className={styles.flexiblePayment}>
                    {CardsStore?.list?.cards
                    ?.filter((card: any) => card?.gatewayCdField === "NI")
                    ?.map(
                      (card: any, index: number) => {
                        const cardLogo =
                          card?.cardType?.toLowerCase() === "visa"
                            ? vissaCard
                            : card?.cardType?.toLowerCase() === "mastercard"
                            ? masterCard
                            : creditCard;

                        return (
                          <label
                            key={index}
                            className={styles.paymentCard}
                            onClick={() => setSelected(`saved_${index}`)}
                          >
                            <input
                              type="radio"
                              name="name"
                              className={styles.radio}
                              value={`saved_${index}`}
                              checked={selected === `saved_${index}`}
                              onChange={() => setSelected(`saved_${index}`)}
                            />
                            <div className={styles.radioWrap}>
                              <div className={styles.radioContent}>
                                <div className={styles.contentTop}>
                                  <span className={styles.radioIcon}></span>
                                  <div className={styles.contentLeft}>
                                    <h5>
                                      ********{card?.cardNumber?.slice(-4)}
                                    </h5>
                                  </div>
                                  <div className={styles.contentRight}>
                                    <img src={cardLogo} alt={card?.cardType} />
                                  </div>
                                </div>
                                <div className={`${styles.contentBottom} mt-0`}>
                                  <span className={styles.expiryDate}>
                                    {General?.codeLabels[
                                      "cm_payment_expiry_date"
                                    ]?.label !== undefined
                                      ? General?.codeLabels[
                                          "cm_payment_expiry_date"
                                        ]?.label
                                      : "Expiry Date"}{" "}
                                    {card?.expiryMonth}/{card?.expiryYear}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </label>
                        );
                      }
                    )}

                    {/* Use New Card */}
                    <label className={styles.paymentCard} key="ni">
                      <input
                        type="radio"
                        name="name"
                        className={styles.radio}
                        value="ni"
                        checked={selected === "ni"}
                        onChange={() => setSelected("ni")}
                      />
                      <div className={styles.radioWrap}>
                        <div className={styles.radioContent}>
                          <div className={styles.contentTop}>
                            <span className={styles.radioIcon}></span>
                            <div className={styles.contentLeft}>
                              <h5>
                                {General?.codeLabels["cm_payment_use_new_card"]
                                  ?.label !== undefined
                                  ? General?.codeLabels[
                                      "cm_payment_use_new_card"
                                    ]?.label
                                  : "Use New Card"}
                              </h5>
                            </div>
                            <div className={styles.contentRight}>
                              <img
                                className={styles.cardBlockImg}
                                src={creditCard}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </label>
                  </div>
                 )}
                {(config?.IsTamara || config?.IsTabby )&& (
                 <h4 className={`${styles.headingH4} ${styles.paymentPlans}`}>
                    {General?.codeLabels["cm_payment_flexible_plans"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_payment_flexible_plans"]?.label
                      : "Flexible Payment Plans "}
                  </h4>
                )}

                  <div className={styles.flexiblePayment}>
                    {config?.IsTabby && isTabbyVisible && (
                      <>
                        {isTabbyVisible &&
                          !isAmountligible &&
                          tabbyErrorMessage && (
                            <p style={{ color: "red", fontSize: "13px" }}>
                             {General?.codeLabels[tabbyErrorMessage.toLowerCase()]?.label !== undefined
                          ? General?.codeLabels[tabbyErrorMessage.toLowerCase()]?.label
                          : tabbyErrorMessage}
                            </p>
                          )}
                        <label className={styles.paymentCard}>
                          <input
                            type="radio"
                            name="name"
                            className={styles.radio}
                            value="tabby"
                            checked={selected === "tabby"}
                            onChange={() => setSelected("tabby")}
                            disabled={
                              !isTabbyEligible ||
                              (isTabbyVisible && !isAmountligible)
                            }
                          />
                          <div className={styles.radioWrap}>
                            <div className={styles.radioContent}>
                              <div className={styles.contentTop}>
                                <span className={styles.radioIcon}></span>
                                <div className={styles.contentLeft}>
                                  <h5>
                                    {General?.codeLabels[
                                      "cm_payment_pay_with_tabby"
                                    ]?.label !== undefined
                                      ? General?.codeLabels[
                                          "cm_payment_pay_with_tabby"
                                        ]?.label
                                      : "Pay Over Time with Tabby"}
                                  </h5>
                                </div>
                                {/* <div className={styles.contentRight}>
                            <img src={tabby} alt="" />
                          </div> */}
                              </div>
                              <div className={styles.contentBottom}>
                                <div
                                  id="TabbyPromo"
                                  style={{ marginTop: "10px" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </label>
                      </>
                    )}
                    {config?.IsTamara &&(
                      <>
                       {!isTamaraAmountEligible && tamaraMessage && (
                      <p style={{ color: "red", fontSize: "13px" }}>
                        {General?.codeLabels[tamaraMessage.toLowerCase()]?.label !== undefined
                          ? General?.codeLabels[tamaraMessage.toLowerCase()]?.label
                          : tamaraMessage}
                      </p>
                    )}
                    <label className={styles.paymentCard}>
                      <input
                        type="radio"
                        name="name"
                        className={styles.radio}
                        value="tamara"
                        checked={selected === "tamara"}
                        onChange={() => setSelected("tamara")}
                        disabled={!isTamaraAmountEligible}
                      />
                      <div className={styles.radioWrap}>
                        <div className={styles.radioContent}>
                          <div className={styles.contentTop}>
                            <span className={styles.radioIcon}></span>
                            <div className={styles.contentLeft}>
                              <h5>
                                {General?.codeLabels[
                                  "cm_payment_pay_with_tamara"
                                ]?.label !== undefined
                                  ? General?.codeLabels[
                                      "cm_payment_pay_with_tamara"
                                    ]?.label
                                  : "Pay Over Time with Tamara"}
                              </h5>
                            </div>
                            {/* <div className={styles.contentRight}>
                            <img src={tamara} alt="" />
                          </div> */}
                          </div>
                          <div className={styles.contentBottom}>
                            <div id="TamaraPromo"></div>
                          </div>
                        </div>
                      </div>
                    </label>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className={styles.paymentAmount}>
                <h3 className={`${styles.headingH3} mb-4`}>
                  {General?.codeLabels["cm_payment_amount_details"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_payment_amount_details"]?.label
                    : "Amount Details"}
                </h3>
                <div className={styles.amountLists}>
                  <div className={styles.amounts}>
                    <div className={styles.amountLeft}>
                      <span>
                        {General?.codeLabels["cm_payment_total_amount"]
                          ?.label !== undefined
                          ? General?.codeLabels["cm_payment_total_amount"]
                              ?.label
                          : "Total Amount"}{" "}
                      </span>
                    </div>
                    <div className={styles.amountRight}>
                      <span>AED {amounts}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.payWrap}>
                <button
                  className={styles.btnPrimary}
                  onClick={handleContinue}
                  // disabled={isLoading || !selected}
                  disabled={
                    emailForm
                      ? !shouldEnable || isLoading || !selected
                      : isLoading || !selected
                  }
                  style={{ color: "#fff" }}
                >
                  {General?.codeLabels["cm_payment_pay_now"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_payment_pay_now"]?.label
                    : "PAY NOW"}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={`${styles.paymentbase}`}>
          <div className={styles.paymentWrap}>
            <div className={styles.paymentSection}>
              {emailForm && (
                <div className={styles.paymentHead}>
                  <div className={styles.modalHeader}>
                    <h3 className={`${styles.headingH3} mb-4`}>
                      {General?.codeLabels["cm_payment_enter_details"]
                        ?.label !== undefined
                        ? General?.codeLabels["cm_payment_enter_details"]?.label
                        : "Enter Your Details to Proceed with Payment"}
                    </h3>
                    {emailForm ? (
                      <button
                        className={`${styles.btnClose}`}
                        onClick={onClose}
                      >
                        <img src={Close} alt="close" />
                      </button>
                    ) : null}
                  </div>
                  <div className="form-group mb-0">
                    <label
                      className={` ${styles.formLabel} ${styles.required}`}
                    >
                      {General?.codeLabels["cm_payment_email"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_payment_email"]?.label
                        : "Email"}
                    </label>
                    <input
                      type="text"
                      className={styles.formControl}
                      placeholder={
                        General?.codeLabels["cm_payment_enter_email"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_payment_enter_email"]?.label
                          : "Enter your email"
                      }
                      value={email}
                      maxLength={254}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        emailRef.current = e.target.value;
                      }}
                    />
                    {email.length > 0 && !isEmailValid && (
                      <span style={{ color: "red", fontSize: "13px" }}>
                        {General?.codeLabels["cm_payment_email_msg"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_payment_email_msg"]?.label
                          : "Please enter a valid email address"}
                      </span>
                    )}
                  </div>
                  <div className={`form-group mb-0 ${styles["mt-3"]}`}>
                    <label
                      className={` ${styles.formLabel} ${styles.required}`}
                    >
                      {General?.codeLabels["cm_payment_mobile_number"]
                        ?.label !== undefined
                        ? General?.codeLabels["cm_payment_mobile_number"]?.label
                        : "Mobile Number"}
                    </label>
                    <div className={styles.phoneInput}>
                      <input
                        type="text"
                        value="+971"
                        disabled
                        className={`${styles.formControl} ${styles.prefixInput}`}
                      />
                      <input
                        type="text"
                        className={styles.formControl}
                        placeholder={
                          General?.codeLabels["cm_payment_enter_number"]
                            ?.label !== undefined
                            ? General?.codeLabels["cm_payment_enter_number"]
                                ?.label
                            : "Enter your number"
                        }
                        value={mobile}
                        onChange={(e) => {
                          setMobile(e.target.value);
                          mobileRef.current = e.target.value;
                        }}
                      />
                    </div>
                    {mobile.length > 0 && !isMobileValid && (
                      <span style={{ color: "red", fontSize: "13px" }}>
                        {General?.codeLabels["cm_payment_mobile_msg"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_payment_mobile_msg"]?.label
                          : "Please enter a valid mobile number (5X-XXX-XXXX)"}
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div className={styles.PaymentMethod}>
                <div className={styles.modalHeader}>
                  <h3 className={`${styles.headingH3} mb-3`}>
                    {General?.codeLabels["cm_payment_select_method"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_payment_select_method"]?.label
                      : "Select a Payment Method"}
                  </h3>
                  {!emailForm ? (
                    <button className={`${styles.btnClose}`} onClick={onClose}>
                      <img src={Close} alt="close" />
                    </button>
                  ) : null}
                </div>
                <div className={styles.cardPayment}>
                  {config?.IsNI && (
                   <label className={styles.paymentCard} key="ni">
                    <input
                      type="radio"
                      name="name"
                      className={styles.radio}
                      value="ni"
                      checked={selected === "ni"}
                      onChange={() => setSelected("ni")}
                    />
                    <div className={styles.radioWrap}>
                      <div className={styles.radioContent}>
                        <div className={styles.contentTop}>
                          <span className={styles.radioIcon}></span>
                          <div className={styles.contentLeft}>
                            <h5>
                              {General?.codeLabels["cm_card_payment"]?.label !==
                              undefined
                                ? General?.codeLabels["cm_card_payment"]?.label
                                : "Card Payment"}
                            </h5>
                          </div>
                          <div className={styles.contentRight}>
                            <img src={creditCard} alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                  )}

                 {(config?.IsTamara || config?.IsTabby )&& (
                 <h4 className={`${styles.headingH4} ${styles.paymentPlans}`}>
                    {General?.codeLabels["cm_payment_flexible_plans"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_payment_flexible_plans"]?.label
                      : "Flexible Payment Plans "}
                  </h4>
                )}

                  <div className={styles.flexiblePayment}>
                    { config?.IsTabby && isTabbyVisible && (
                      <>
                        {(!isTabbyEligible ||
                          (isTabbyVisible && !isAmountligible)) &&
                          tabbyErrorMessage && (
                            <p style={{ color: "red", fontSize: "13px" }}>
                              {tabbyErrorMessage}
                            </p>
                          )}

                        <label className={styles.paymentCard}>
                          <input
                            type="radio"
                            name="name"
                            className={styles.radio}
                            value="tabby"
                            checked={selected === "tabby"}
                            onChange={() => setSelected("tabby")}
                            disabled={
                              !isTabbyEligible ||
                              (isTabbyVisible && !isAmountligible)
                            }
                          />
                          <div className={styles.radioWrap}>
                            <div className={styles.radioContent}>
                              <div className={styles.contentTop}>
                                <span className={styles.radioIcon}></span>
                                <div className={styles.contentLeft}>
                                  <h5>
                                    {General?.codeLabels[
                                      "cm_payment_pay_with_tabby"
                                    ]?.label !== undefined
                                      ? General?.codeLabels[
                                          "cm_payment_pay_with_tabby"
                                        ]?.label
                                      : "Pay Over Time with Tabby"}
                                  </h5>
                                </div>
                                {/* <div className={styles.contentRight}>
                            <img src={tabby} alt="" />
                          </div> */}
                              </div>
                              <div className={styles.contentBottom}>
                                <div
                                  id="TabbyPromo"
                                  style={{ marginTop: "10px" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </label>
                          
                      </>
                    )}
                    
                  {config?.IsTamara && (
                      <> 
                       {!isTamaraAmountEligible && tamaraMessage && (
                          <p style={{ color: "red", fontSize: "13px" }}>
                            {tamaraMessage}
                          </p>
                        )}
                        <label className={styles.paymentCard}>
                          <input
                            type="radio"
                            name="name"
                            className={styles.radio}
                            value="tamara"
                            checked={selected === "tamara"}
                            onChange={() => setSelected("tamara")}
                            disabled={!isTamaraAmountEligible}
                          />
                          <div className={styles.radioWrap}>
                            <div className={styles.radioContent}>
                              <div className={styles.contentTop}>
                                <span className={styles.radioIcon}></span>
                                <div className={styles.contentLeft}>
                                  <h5>
                                    {General?.codeLabels[
                                      "cm_payment_pay_with_tamara"
                                    ]?.label !== undefined
                                      ? General?.codeLabels[
                                          "cm_payment_pay_with_tamara"
                                        ]?.label
                                      : "Pay Over Time with Tamara"}
                                  </h5>
                                </div>
                                {/* <div className={styles.contentRight}>
                            <img src={tamara} alt="" />
                          </div> */}
                              </div>
                              <div className={styles.contentBottom}>
                                <div id="TamaraPromo"></div>
                              </div>
                            </div>
                          </div>
                        </label>
                       </>
                  )}
                     
                  </div>
                </div>
              </div>
              <div className={styles.paymentAmount}>
                <h3 className={`${styles.headingH3} mb-4`}>
                  {General?.codeLabels["cm_payment_amount_details"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_payment_amount_details"]?.label
                    : "Amount Details"}
                </h3>
                <div className={styles.amountLists}>
                  <div className={styles.amounts}>
                    <div className={styles.amountLeft}>
                      <span>
                        {General?.codeLabels["cm_payment_total_amount"]
                          ?.label !== undefined
                          ? General?.codeLabels["cm_payment_total_amount"]
                              ?.label
                          : "Total Amount"}
                      </span>
                    </div>
                    <div className={styles.amountRight}>
                      <span>AED {amounts}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.payWrap}>
                <button
                  className={styles.btnPrimary}
                  onClick={handleContinue}
                  // disabled={isLoading || !selected}
                  disabled={
                    emailForm
                      ? !shouldEnable || isLoading || !selected
                      : isLoading || !selected
                  }
                  style={{ color: "#fff" }}
                >
                  {General?.codeLabels["cm_payment_pay_now"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_payment_pay_now"]?.label
                    : "PAY NOW"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255, 254, 254, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <Spinner width="100px" height="100px" color="#ffffff" />
        </div>
      )}
    </div>
  );
};

export default GatewaySelection;
